/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListAllAccountItemQueryResponse } from './ListAllAccountItemQueryResponse';
import {
    ListAllAccountItemQueryResponseFromJSON,
    ListAllAccountItemQueryResponseFromJSONTyped,
    ListAllAccountItemQueryResponseToJSON,
} from './ListAllAccountItemQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListAllAccountQueryResponse
 */
export interface ListAllAccountQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListAllAccountQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<ListAllAccountItemQueryResponse>}
     * @memberof ListAllAccountQueryResponse
     */
    data: Array<ListAllAccountItemQueryResponse>;
}

/**
 * Check if a given object implements the ListAllAccountQueryResponse interface.
 */
export function instanceOfListAllAccountQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListAllAccountQueryResponseFromJSON(json: any): ListAllAccountQueryResponse {
    return ListAllAccountQueryResponseFromJSONTyped(json, false);
}

export function ListAllAccountQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAllAccountQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(ListAllAccountItemQueryResponseFromJSON)),
    };
}

export function ListAllAccountQueryResponseToJSON(value?: ListAllAccountQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(ListAllAccountItemQueryResponseToJSON)),
    };
}

